const sections = Object.freeze({
  // Setup tab
  details: ['title', 'category_id'],
  channels: [
    'email',
    'sms',
    'ios_push',
    'android_push',
    'web_push',
    'inbox',
    'inapp',
    'inapp_ios',
    'inapp_android',
    'onsite',
    'webhook',
    'whatsapp',
    'facebook'
  ],
  promotions: [
    'promotion',
    'promotion_id',
    'promotion_action',
    'promotion_params',
    'promotion_amount',
    'promotion_amount_type',
    'promotion_amount_attribute_title',
    'promotion_amount_metric_title',
    'promotion_amount_property_title',
    'promotion_amount_window',
    'promotion_amount_daterange',
    'promotion_amount_percents',
    'promotion_amount_round',
    'promotion_amount_min',
    'promotion_amount_cap',
    'promotion_duration'
  ],
  variants: [
    'ab',
    'ab_cg',
    'ab_cg_size',
    'ab_variants',
    'variants',
    'automatically_pick_winner',
    'automatically_pick_winner_after_n',
    'automatically_pick_winner_after_period',
    'automatically_pick_winner_sample_channel',
    'automatically_pick_winner_sample_type',
    'automatically_pick_winner_sample_percentage',
    'automatically_pick_winner_schedule_status'
  ],
  multilanguage: ['languages_multi', 'languages_default', 'languages_list'],
  content_fetch: ['content_fetch', 'content_fetch_sources'],
  conversions: ['conversions', 'goal_conditions'],
  voucher_codes: ['voucher_codes_enabled', 'voucher_codes_file'],
  // Events tab:
  event: ['event', 'event_title'],
  eventFilter: ['event_filter', 'event_conditions'],
  eventDelay: ['event_mode', 'event_delay_time', 'event_delay_period'],
  eventLimits: [
    'event_limit_per_user',
    'event_limit_per_user_scope',
    'event_limit_per_user_period',
    'event_limit_nth_hit',
    'event_limit_nth_hit_scope',
    'event_limit_nth_hit_period'
  ],
  // Locations tab
  locationTrigger: ['location_trigger', 'location_dwell_time'],
  locations: ['locations'],
  locationLimits: [
    'location_limit_per_user',
    'location_limit_per_user_period',
    'location_limit_per_location',
    'location_limit_per_location_period',
    'location_limit_nth_hit',
    'location_limit_nth_hit_period'
  ],
  // Segments tab
  seedList: ['seed_list_enabled'],
  targetUsers: [
    'target_applications',
    'target_application_enabled',
    'target_devices'
  ],
  broadcast: ['broadcast', 'conditions'],
  target: [
    'email_addressable',
    'inbox_addressable',
    'sms_addressable',
    'webhook_addressable'
  ],
  environments: [
    'ios_push_production',
    'ios_push_sandbox',
    'ios_push_legacy',
    'android_push_production',
    'android_push_legacy'
  ],
  webPush: ['web_push_safari', 'web_push_chrome', 'web_push_firefox'],
  encryption: ['encryption'],
  // Schedule tab:
  schedule: [
    // Unused
    'send_type',
    'send_date',
    'send_time',
    'send_days',
    'send_option',
    'send_interval',
    'send_frequency',
    'start_date',
    'start_time',
    'start_date_time',
    'end_date',
    'end_time',
    'end_date_time',
    'timezone',
    'prepare_interval_enabled',
    'prepare_interval',
    'optimove_type',
    'trigger'
  ],
  offlineUsers: ['retry_type', 'retry_for', 'retry_for_period', 'retry_until'],
  persistContent: [
    'persist_type',
    'persist_for',
    'persist_for_period',
    'persist_until'
  ],
  earlyCancelEvent: [
    'early_cancel_event_title',
    'early_cancel_event_filter',
    'early_cancel_event_conditions'
  ],
  journeyOptions: ['enter_journey_once_ever', 'enter_journey_once_at_a_time'],
  qualification: [
    'qualification',
    'qualification_event_title',
    'qualification_event_filter',
    'qualification_event_conditions',
    'qualification_time',
    'qualification_period'
  ],
  accumulation: ['accumulation_conditions']
})

export { sections }



// WEBPACK FOOTER //
// ./src/modules/campaign-manage/enum/CampaignModelDiffMap.js